<template>
  <a-table
    :dataSource="data"
    :columns="columns"
    :loading="loading"
    :pagination="{
      hideOnSinglePage: true,
      total: total,
      current: currentPage,
      defaultPageSize: limit,
    }"
    rowKey="time"
    class="ant-table-striped"
    :rowClassName="
      (record, index) => (record.status == 'LOCKED' ? 'table-striped' : null)
    "
  >
    <template #name="{ text }"> {{ text }} </template>
    <template #username="{ text }"> {{ text }} </template>
    <template #email="{ text }">
      {{ text }}
    </template>
    <template #status="{ text }">
      {{ text }}
    </template>

    <!-- <template #tool="{ text }">
        <a-dropdown :trigger="['click']">
          <a class="ant-dropdown-link" @click.prevent>
            <SettingOutlined />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <a
                  href="javascript:;"
                  @click="
                    showStatusModal = true;
                    upateStatusI = text;
                    newStatus = list[text].status;
                  "
                  >Status</a
                >
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="openRolesModal(text)">Roles</a>
              </a-menu-item>
             
              <a-menu-item>
                <a
                  href="javascript:;"
                  @click.stop.prevent="showDeleteConfirm(text)"
                  >Delete</a
                >
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template> -->
  </a-table>
</template>

<script>
// @ is an alias to /src

import { reactive, toRefs } from "@vue/reactivity";

import { SettingOutlined } from "@ant-design/icons-vue";
import { inject } from "@vue/runtime-core";
const columns = [
  {
    title: "Time",
    dataIndex: "time",
  },

  {
    title: "OnTime Count",
    dataIndex: "onTimeCount",
  },
  {
    title: "AdvanceCount",
    dataIndex: "advanceCount",
    slots: { customRender: "dueDate" },
  },
  {
    title: "AdvanceTime",
    dataIndex: "advanceTime",
    slots: { customRender: "lastLoginTime" },
  },
  {
    title: "Overdue Count",
    dataIndex: "overdueCount",
    slots: { customRender: "lastLoginTime" },
  },
  {
    title: "Overdue Time",
    dataIndex: "overdueTime",
    slots: { customRender: "lastLoginTime" },
  },
  {
    title: "postpone Countt",
    dataIndex: "postponeCount",
    slots: { customRender: "lastLoginTime" },
  },
  {
    title: "postpone Num",
    dataIndex: "postponeNum",
    slots: { customRender: "lastLoginTime" },
  },
  {
    title: "postpone Time",
    dataIndex: "postponeTime",
    slots: { customRender: "lastLoginTime" },
  },

  // {
  //   title: "...",
  //   key: "tool",
  //   dataIndex: "key",
  //   slots: { customRender: "tool" },
  // },
];
export default {
  components: {
    SettingOutlined,
  },
  props: {
    data: { type: Array },
    loading: { type: Boolean },
  },
  setup(props) {
    const { $msg, $gql } = inject("$");
    const v = reactive({
      limit: 20,
      total: 0,
      currentPage: 1,
      page: 1,
    });

    function tableChange(index) {
      v.page = index.current;
      v.currentPage = index.current;
    }

    return {
      ...toRefs(v),
      columns,
      tableChange,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/style/mixins";

.content {
  background-color: $color-white;
  padding: 15px;
}
</style>
